import { useQuery } from '@tanstack/react-query';
import { getScenario } from '../../../common/api/scenarios';
import { useParams } from 'react-router-dom'; // Assuming you're using React Router for navigation
import { Spinner } from '@cloudscape-design/components'; // Importing the Spinner component
import { ScenarioView } from './scenario';
import { Loading } from '../../../components/Loading';

export default function View() {
  const params = useParams();
  const scenarioUuid = params.scenarioUuid;

  const getQuery = useQuery({
    queryKey: ['scenarios', scenarioUuid],
    queryFn: () => (scenarioUuid ? getScenario(scenarioUuid) : null),
    enabled: true,
    // room membership is always changing, so we don't want to cache it
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
  const scenario = getQuery.data;

  if (getQuery.isLoading || !getQuery.data || !scenario) {
    // TODO error handling
    return <Loading />;
  }

  return <ScenarioView scenario={scenario} />;
}
